import { Project } from '../types';

const normalize = (value?: string | null) => String(value || '').trim().toLowerCase();

const titleToSlugMap: Record<string, string> = {
  sevenoir: 'sevenoir',
  oraculore: 'oraculore',
  wealthernal: 'wealthernal',
  skilloton: 'skilloton',
  '13 players club': '13-players-club',
  '13-players-club': '13-players-club',
  'pantheon ai': 'pantheon-ai',
  'pantheon-ai': 'pantheon-ai',
  'coast essence': 'coast-essence',
  'coast-essence': 'coast-essence'
};

export const slugify = (value?: string | null) =>
  normalize(value)
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const resolveProjectSlug = (projectLike: Partial<Project> & { title?: string; name?: string; slug?: string }) => {
  const explicitSlug = slugify(projectLike.slug);
  if (explicitSlug) return explicitSlug;

  const title = normalize(projectLike.title || projectLike.name);
  if (title && titleToSlugMap[title]) return titleToSlugMap[title];
  if (title) return slugify(title);

  const idSlug = slugify(projectLike.id);
  if (idSlug) {
    const isUuidLike = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(idSlug);
    if (!isUuidLike) return idSlug;
    return `project-${idSlug.slice(0, 8)}`;
  }

  return 'project';
};

export const getProjectPath = (project: Partial<Project>) => `/portfolio/${resolveProjectSlug(project)}`;
